var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('document-info-card',{attrs:{"title":"My Documents","data":[],"documentIndex":"","documentClassifications":"documentClassifications"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }